import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const UnionPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.UNIONPAY}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.UNIONPAY)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.UNIONPAY)} alt="union-pay" />
    </Box>
  );
};
